import { Grid2, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Shield } from '@mui/icons-material';
import ButtonComponent from '../../../../components/ButtonComponent';

interface AlarmCentralHeaderActionContainerProps {
  name: string;
  shieldColor: 'error' | 'success';
  statusTextColor: 'error' | 'success';
  statusText?: 'Armada' | 'Desarmada';
  isTotalArmed: boolean;
  isRenderArmed?: boolean;
  iconArmOrDisarmButton: ReactElement<any, any>;
  onClickArmOrDisarmButton: () => void;
  isLoadingArmOrDisarmCompleteAlarmCentral?: boolean;
}

const AlarmCentralHeaderActionContainer = ({
  name,
  shieldColor,
  statusTextColor,
  statusText,
  onClickArmOrDisarmButton,
  isLoadingArmOrDisarmCompleteAlarmCentral,
  isTotalArmed,
  iconArmOrDisarmButton,
  isRenderArmed = false,
}: AlarmCentralHeaderActionContainerProps) => {
  return (
    <>
      <Grid2
        size={4}
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          {name}
        </Typography>
        {statusText && (
          <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
            <Shield color={shieldColor} sx={{ mb: 0.5, mr: 0.5 }} />
            <Typography
              color={statusTextColor}
              style={{ fontWeight: 'bold', fontSize: 18 }}
            >
              {statusText}
            </Typography>
          </Grid2>
        )}
      </Grid2>

      <Grid2 size={8} sx={{ justifyContent: 'end', display: 'flex' }}>
        {isRenderArmed && (
          <ButtonComponent
            startIcon={iconArmOrDisarmButton}
            color={'primary'}
            loading={isLoadingArmOrDisarmCompleteAlarmCentral}
            onClick={onClickArmOrDisarmButton}
          >
            {isTotalArmed ? 'Desarmar total' : 'Armar total'}
          </ButtonComponent>
        )}
      </Grid2>
    </>
  );
};

export default AlarmCentralHeaderActionContainer;
